import styled from 'styled-components';

export const RangeSliderBox = styled.div`
 margin-top:33px;
 margin-bottom:25px;
 position: relative;

 .ant-slider-track {
    background: #01606F !important;
    height: 10px !important;
}
 .ant-slider-rail {
    height: 10px !important;
}
.ant-slider-handle::after {
    width: 20px !important;
    height: 20px !important;
    border: 4px solid #01606F;
    box-shadow: none !important;
}
.ant-tooltip .ant-tooltip-inner {
    background-color: transparent !important;
    font-family: "Jost", sans-serif  !important;
    font-size: 18px  !important;
    font-weight: 600  !important;
    line-height: 27px  !important;
    margin-bottom: 0  !important;
    color: #000 !important;
    box-shadow: none !important;
  }
  .ant-tooltip-arrow {
    display: none !important;
  }
`;

export const Dashboard = styled.div``;

export const DashboardList = styled.ul`
    padding: 0;
    margin: 0 0 20px 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
   
`;
export const DashboardItem = styled.li`
  position: relative;
     &:after {
            position: absolute;
            width: 2px;
            height: 100%;
            content: "";
            background: #3333336e;
            right: -24px;
            top: 0;
        }
     &:last-child{
        &:after {
            display:none;
        }
     }   
    
`;
export const ItemTitle = styled.h4`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 600;
    line-height:27px;
    margin-bottom: 8px;
    
    @media screen and (max-width: 480px){
        font-size: 12px;
        line-height: 20px;
    }
`;


export const ItemNumber = styled.span`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 600;
    line-height:27px;
    margin-bottom: 0px;
    
    @media screen and (max-width:1199px) {
        font-size:15px;
    }
    
    @media screen and (max-width:991px) {
        font-size:16px;
    }
    
    @media screen and (max-width: 480px){
        font-size: 12px;
        line-height: 20px;
    }
`;



export const ReviewNoCounter = styled.p`
     color: #;
     font-size: 16px;
     font-family: 'Jost', sans-serif;
     font-weight: 400;
     line-height: 20px;
     margin:0;

    &.review-no-counter{
        display: none;
    }
`;

export const ReviewNoCounterSpan = styled.span``;

